import { ROUTES } from "@/config/routes";
import { useGetCollectionList } from "@/hooks/api/content.hooks";

import Section from "../helpers/Section/Section";
import MoviesSectionSlider from "../slider/MoviesSectionSlider";

interface CollectionSection {
  from: number;
  to: number;
}

const MainMoviesCollectionSection = ({ from, to }: CollectionSection) => {
  const { data } = useGetCollectionList();
  return (
    <div>
      {data.slice(from, to).map((section, index) => (
        <Section
          key={index}
          title={section.title}
          link={ROUTES.MAIN.COLLECTION.replace(":id", section.id.toString())}
          className={`group/section`}
        >
          <MoviesSectionSlider sectionName={section.id.toString()} contents={section.contents} />
        </Section>
      ))}
    </div>
  );
};

export default MainMoviesCollectionSection;
